import { useTranslation } from 'react-i18next'
import React, { FC } from 'react'
import { IDownPaymentDetails } from '@linqpal/models/src/types/routes'
import { PaymentStepContainer } from './PaymentStepContainer'
import { DownPaymentForm } from '../Credit/DownPayment/DownPaymentForm'
import { DownPaymentMethod } from '@linqpal/models/src/dictionaries/downPayment'
import { BtButton } from '@linqpal/components/src/ui'
import { StyleSheet, View } from 'react-native'

interface IProps {
  downPayment: IDownPaymentDetails
  onBack: () => void
  onClose: () => void
  onContinue: (downPayment: IDownPaymentDetails) => void
}

export const DownPaymentStep: FC<IProps> = ({
  downPayment,
  onBack,
  onClose,
  onContinue,
}) => {
  const { t } = useTranslation('global')

  const [downPaymentDetails, setDownPaymentDetails] =
    React.useState<IDownPaymentDetails>({
      paymentMethod: DownPaymentMethod.Card,
      accountId: '',
      ...downPayment, // take previously selected percentage and amount
    })

  const canContinue =
    downPaymentDetails.paymentMethod === DownPaymentMethod.Wire ||
    !!downPaymentDetails.accountId

  return (
    <PaymentStepContainer
      title={t('payInvoice.pay-invoice')}
      onBack={onBack}
      onClose={onClose}
    >
      <View style={styles.wrapper}>
        <DownPaymentForm
          downPayment={downPaymentDetails}
          onChange={setDownPaymentDetails}
        />
      </View>

      <BtButton
        disabled={!canContinue}
        onPress={() => onContinue(downPaymentDetails)}
        style={styles.continueButton}
        testID="down-payment-step-continue-button"
      >
        {t('DownPaymentModal.continue')}
      </BtButton>
    </PaymentStepContainer>
  )
}

const styles = StyleSheet.create({
  wrapper: {
    marginTop: 38,
  },
  continueButton: {
    width: 120,
    marginTop: 32,
    alignSelf: 'flex-end',
  },
})
